<app-loading [loaded]="news"></app-loading>

<div *ngIf="news">

  <h1>{{news.title}}</h1>

  <div [innerHtml]="news.content|safeHtml"></div>

</div>
